module.exports = __webpack_public_path__ + "static/media/YM02_2.c67bdb7d.jpg";